module.exports = {
          srcSet: __webpack_public_path__ + "0a995916f465070259ec244280142baa-491.png"+" 491w",
          images:[ {path: __webpack_public_path__ + "0a995916f465070259ec244280142baa-491.png",width: 491,height: 329}],
          src: __webpack_public_path__ + "0a995916f465070259ec244280142baa-491.png",
          toString:function(){return __webpack_public_path__ + "0a995916f465070259ec244280142baa-491.png"},
          
          width: 491,
          height: 329
        }